
import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import BenefitsSection from './components/BenefitsSection';
import ROICalculator from './components/ROICalculator';
import FAQSection from './components/FAQSection';
import ProcessSection from './components/ProcessSection';
import CaseStudies from './components/CaseStudies';
import StorySection from './components/StorySection';
import CTASection from './components/CTASection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function Home() {
  const [showContactForm, setShowContactForm] = useState(false);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <Hero onShowForm={() => setShowContactForm(true)} />
      <ProblemSection />
      <SolutionSection />
      <BenefitsSection />
      <ROICalculator />
      <FAQSection />
      <ProcessSection />
      <CaseStudies />
      <StorySection />
      <CTASection onShowForm={() => setShowContactForm(true)} />
      <ContactForm isOpen={showContactForm} onClose={() => setShowContactForm(false)} />
      <Footer />
    </div>
  );
}
